"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScheduleEntryTypeIcon = void 0;
var ScheduleEntryTypeIcon;
(function (ScheduleEntryTypeIcon) {
    ScheduleEntryTypeIcon["ASSIGNMENT"] = "ASSIGNMENT";
    ScheduleEntryTypeIcon["FLAG"] = "FLAG";
    ScheduleEntryTypeIcon["BEACH"] = "BEACH";
    ScheduleEntryTypeIcon["CAKE"] = "CAKE";
    ScheduleEntryTypeIcon["CAR"] = "CAR";
    ScheduleEntryTypeIcon["PEN"] = "PEN";
    ScheduleEntryTypeIcon["LAPTOP"] = "LAPTOP";
    ScheduleEntryTypeIcon["LIST"] = "LIST";
    ScheduleEntryTypeIcon["CAMERA"] = "CAMERA";
    ScheduleEntryTypeIcon["FLOWER"] = "FLOWER";
    ScheduleEntryTypeIcon["OFFER"] = "OFFER";
    ScheduleEntryTypeIcon["LOCK"] = "LOCK";
    ScheduleEntryTypeIcon["LOOP"] = "LOOP";
    ScheduleEntryTypeIcon["MAIL"] = "MAIL";
    ScheduleEntryTypeIcon["PHONE"] = "PHONE";
    ScheduleEntryTypeIcon["POWER"] = "POWER";
    ScheduleEntryTypeIcon["SCHEDULE"] = "SCHEDULE";
    ScheduleEntryTypeIcon["WORK"] = "WORK";
    ScheduleEntryTypeIcon["KEY"] = "KEY";
    ScheduleEntryTypeIcon["CLOSED"] = "CLOSED";
    ScheduleEntryTypeIcon["GAVEL"] = "GAVEL";
    ScheduleEntryTypeIcon["HOTEL"] = "HOTEL";
    ScheduleEntryTypeIcon["WARNING"] = "WARNING";
    ScheduleEntryTypeIcon["BATTERY"] = "BATTERY";
    ScheduleEntryTypeIcon["BELL"] = "BELL";
    ScheduleEntryTypeIcon["TOOL"] = "TOOL";
})(ScheduleEntryTypeIcon = exports.ScheduleEntryTypeIcon || (exports.ScheduleEntryTypeIcon = {}));
//# sourceMappingURL=ScheduleEntryTypeIcon.js.map